import React, { useState } from "react";
import { Card, PageHeader, Button } from "../../../components/common";
import { AnnouncementCard } from "../../../components/Announcement";
import AnnouncementModal from "../../../components/Announcement/AnnouncementModal";
import { useAppSelector } from "../../../redux";
import "./TeacherDashboard.css";

const TeacherDashboard: React.FC = () => {
  const user = useAppSelector((state) => state.auth.user);
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Card style={{ padding: "24px" }}>
        <PageHeader
          title="Teacher Dashboard"
          subtitle="Welcome to your Akshar Art Teacher Portal."
        />
      </Card>
      <AnnouncementCard
        headerAction={
          user?.Master && (
            <Button
              type="button"
              variant="primary"
              size="small"
              onClick={() => setIsAnnouncementModalOpen(true)}
            >
              Create Announcement
            </Button>
          )
        }
      />
      {user?.Master && (
        <AnnouncementModal
          isOpen={isAnnouncementModalOpen}
          onClose={() => setIsAnnouncementModalOpen(false)}
        />
      )}
    </div>
  );
};

export default TeacherDashboard;
